// navigation accesibility module
import lib from './lib';

/**
 * @deprecated
 */
export default class TouchNav {
	constructor(opt) {
		this.options = {
			hoverClass: 'hover',
			menuItems: 'li',
			menuOpener: 'a',
			menuDrop: 'ul',
			navBlock: null,
		};
		for (const p in opt) {
			if (opt.hasOwnProperty(p)) {
				this.options[p] = opt[p];
			}
		}
		this.init();
		this.isPointerDevice = (() =>
			!!(navigator.pointerEnabled || navigator.msPointerEnabled))();
		this.isTouchDevice = (() =>
			!!(
				'ontouchstart' in window ||
				(window.DocumentTouch && document instanceof DocumentTouch)
			))();
	}

	init() {
		if (typeof this.options.navBlock === 'string') {
			this.menu = document.getElementById(this.options.navBlock);
		} else if (typeof this.options.navBlock === 'object') {
			this.menu = this.options.navBlock;
		}
		if (this.menu) {
			this.addEvents();
		}
	}

	addEvents() {
		const touchEvent =
			(navigator.pointerEnabled && 'pointerdown') ||
			(navigator.msPointerEnabled && 'MSPointerDown') ||
			(this.isTouchDevice && 'touchstart');

		this.menuItems = lib.queryElementsBySelector(
			this.options.menuItems,
			this.menu
		);

		const initMenuItem = (item) => {
			const currentDrop = lib.queryElementsBySelector(
				this.options.menuDrop,
				item
			)[0];
			const currentOpener = lib.queryElementsBySelector(
				this.options.menuOpener,
				item
			)[0];

			// only for touch input devices
			if (
				currentDrop &&
				currentOpener &&
				(this.isTouchDevice || this.isPointerDevice)
			) {
				lib.event.add(
					currentOpener,
					'click',
					lib.bind(this.clickHandler, this)
				);
				lib.event.add(
					currentOpener,
					'mousedown',
					lib.bind(this.mousedownHandler, this)
				);
				lib.event.add(currentOpener, touchEvent, (e) => {
					if (!this.isTouchPointerEvent(e)) {
						this.preventCurrentClick = false;
						return;
					}
					this.touchFlag = true;
					this.currentItem = item;
					this.currentLink = currentOpener;
					this.pressHandler.apply(this, arguments);
				});
			}
			// for desktop computers and touch devices
			jQuery(item).on('mouseenter', () => {
				if (!this.touchFlag) {
					this.currentItem = item;
					this.mouseoverHandler();
				}
			});
			jQuery(item).on('mouseleave', () => {
				if (!this.touchFlag) {
					this.currentItem = item;
					this.mouseoutHandler();
				}
			});
			item.touchNavActive = true;
		};

		// addd handlers for all menu items
		for (let i = 0; i < this.menuItems.length; i++) {
			initMenuItem(this.menuItems[i]);
		}

		// hide dropdowns when clicking outside navigation
		if (this.isTouchDevice || this.isPointerDevice) {
			lib.event.add(
				document.documentElement,
				'mousedown',
				lib.bind(this.clickOutsideHandler, this)
			);
			lib.event.add(
				document.documentElement,
				touchEvent,
				lib.bind(this.clickOutsideHandler, this)
			);
		}
	}

	mousedownHandler(e) {
		if (this.touchFlag) {
			e.preventDefault();
			this.touchFlag = false;
			this.preventCurrentClick = false;
		}
	}

	mouseoverHandler() {
		lib.addClass(this.currentItem, this.options.hoverClass);
		jQuery(this.currentItem).trigger('itemhover');
	}

	mouseoutHandler() {
		lib.removeClass(this.currentItem, this.options.hoverClass);
		jQuery(this.currentItem).trigger('itemleave');
	}

	hideActiveDropdown() {
		for (let i = 0; i < this.menuItems.length; i++) {
			if (lib.hasClass(this.menuItems[i], this.options.hoverClass)) {
				lib.removeClass(this.menuItems[i], this.options.hoverClass);
				jQuery(this.menuItems[i]).trigger('itemleave');
			}
		}
		this.activeParent = null;
	}

	pressHandler(e) {
		// hide previous drop (if active)
		if (this.currentItem !== this.activeParent) {
			if (
				this.activeParent &&
				this.currentItem.parentNode === this.activeParent.parentNode
			) {
				lib.removeClass(this.activeParent, this.options.hoverClass);
			} else if (!this.isParent(this.activeParent, this.currentLink)) {
				this.hideActiveDropdown();
			}
		}
		// handle current drop
		this.activeParent = this.currentItem;
		if (lib.hasClass(this.currentItem, this.options.hoverClass)) {
			this.preventCurrentClick = false;
		} else {
			e.preventDefault();
			this.preventCurrentClick = true;
			lib.addClass(this.currentItem, this.options.hoverClass);
			jQuery(this.currentItem).trigger('itemhover');
		}
	}

	clickHandler(e) {
		// prevent first click on link
		if (this.preventCurrentClick) {
			e.preventDefault();
		}
	}

	clickOutsideHandler(event) {
		const e = event.changedTouches ? event.changedTouches[0] : event;
		if (this.activeParent && !this.isParent(this.menu, e.target)) {
			this.hideActiveDropdown();
			this.touchFlag = false;
		}
	}

	isParent(parent, child) {
		while (child.parentNode) {
			if (child.parentNode === parent) {
				return true;
			}
			child = child.parentNode;
		}
		return false;
	}

	isTouchPointerEvent(e) {
		return (
			e.type.indexOf('touch') > -1 ||
			(navigator.pointerEnabled && e.pointerType === 'touch') ||
			(navigator.msPointerEnabled && e.pointerType === e.MSPOINTER_TYPE_TOUCH)
		);
	}

	static isActiveOn(elem) {
		return elem?.touchNavActive;
	}
}
